import React, { useState, useEffect } from "react";
import "../components/css/addnew.css";

function AddNew() {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [image, setImage] = useState(null);
    const [video, setVideo] = useState("");
    const [message, setMessage] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetchPostsFromMongoDB(); 
    }, []);

    const fetchPostsFromMongoDB = async () => {
        try {
            const response = await fetch("https://ghada-m2cb.onrender.com/api/posts"); // Ensure the correct URL
            const data = await response.json();
            setPosts(data);
        } catch (error) {
            console.error("Error loading posts:", error);
            setMessage("حدث خطأ أثناء تحميل المدونات");
        }
    };

    // Handle image upload
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result); // Save Base64 encoded image
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle form submission for adding/updating posts
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate video URL if provided
        if (video && !video.includes("https://www.youtube.com/watch")) {
            setMessage("رابط الفيديو غير صالح، يرجى التأكد من رابط YouTube.");
            return;
        }

        const newPost = {
            title,
            content,
            image,
            video,
            date: new Date().toLocaleDateString(),
        };

        try {
            let response;
            if (editingId) {
                // Update existing post
                response = await fetch(`http://localhost:5000/api/posts/${editingId}`, { // Use absolute URL
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(newPost),
                });
                if (!response.ok) {
                    throw new Error("Failed to update post");
                }
                setMessage("تم تعديل المدونة بنجاح");
                setEditingId(null); // Reset editing state
            } else {
                // Create a new post
                response = await fetch("http://localhost:5000/api/posts", { // Use absolute URL
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(newPost),
                });
                if (!response.ok) {
                    throw new Error("Failed to add post");
                }
                setMessage("تم إضافة المدونة بنجاح");
            }

            // Fetch updated posts after submission
            fetchPostsFromMongoDB();
        } catch (error) {
            console.error("Error saving post:", error);
            setMessage("حدث خطأ أثناء حفظ المدونة");
        }

        // Reset form
        setTitle("");
        setContent("");
        setImage(null);
        setVideo("");
    };

    // Handle post editing
    const handleEdit = (post) => {
        setTitle(post.title);
        setContent(post.content);
        setImage(post.image);
        setVideo(post.video);
        setEditingId(post._id); // Track which post is being edited
    };

    // Handle post deletion
    const handleDelete = async (id) => {
        try {
            await fetch(`http://localhost:5000/api/posts/${id}`, { method: "DELETE" });
            setMessage("تم حذف المدونة بنجاح");
            fetchPostsFromMongoDB(); // Refresh posts after deletion
        } catch (error) {
            console.error("Error deleting post:", error);
            setMessage("حدث خطأ أثناء حذف المدونة");
        }
    };

    return (
        <div className="add-post-container">
            <h1>{editingId ? "تعديل المدونة" : "إضافة مدونة جديدة"}</h1>
            {message && <p className="message">{message}</p>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>العنوان:</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>المحتوى:</label>
                    <textarea
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>صورة:</label>
                    <input
                        type="file"
                        onChange={handleImageChange}
                        accept="image/*"
                    />
                    {image && <img src={image} alt="Preview" style={{ width: "100px" }} />}
                </div>
                <div className="form-group">
                    <label>رابط الفيديو (YouTube):</label>
                    <input
                        type="text"
                        value={video}
                        onChange={(e) => setVideo(e.target.value)}
                        placeholder="https://www.youtube.com/watch?v=..."
                    />
                </div>
                <button type="submit">
                    {editingId ? "تعديل المدونة" : "إضافة المدونة"}
                </button>
            </form>

            {/* List of posts */}
            <div className="posts-list">
                <h2>قائمة المدونات</h2>
                {posts.length > 0 ? (
                    posts.map((post) => (
                        <div key={post._id} className="post-item">
                            <h3>{post.title}</h3>
                            <p>{post.date}</p>
                            {post.image && <img src={post.image} alt={post.title} style={{ width: "100px" }} />}
                            {post.video && (
                                <a href={post.video} target="_blank" rel="noopener noreferrer">
                                    مشاهدة الفيديو
                                </a>
                            )}
                            <div className="action-buttons">
                                <button onClick={() => handleEdit(post)}>تعديل</button>
                                <button onClick={() => handleDelete(post._id)}>حذف</button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>لا توجد مدونات بعد</p>
                )}
            </div>
        </div>
    );
}

export default AddNew;
